import { defaultFilter } from 'cmdk';

/** A keyword hit ranks below a label hit: the label is the row's real name. */
const KEYWORD_WEIGHT = 0.9;

/**
 * cmdk's default fuzzy-matches the query against label + keywords joined into
 * one string, so letters from unrelated synonyms chain into junk matches
 * ("help" hit Browser extension via chrome/linkedin/plugin). Labels stay fuzzy;
 * a keyword only counts when the query appears inside it.
 */
export function paletteFilter(
  value: string,
  search: string,
  keywords: string[] = []
): number {
  const query = search.trim().toLowerCase();
  let keyword = 0;
  for (const k of keywords) {
    if (k.toLowerCase().includes(query)) {
      keyword = Math.max(keyword, defaultFilter(k, search, []));
    }
  }
  return Math.max(defaultFilter(value, search, []), KEYWORD_WEIGHT * keyword);
}
